import { useState } from 'react'
import { useApolloClient } from '@apollo/client'
import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons'
import { ORDER_CONFIRMATION } from '@Orders/constants'

import Button from '~/core/Button'

import { downloadInvoiceUri } from './logic'

export const BUTTON_MARGIN = { marginLeft: '8px' }

type DownloadOrderConfirmationButtonPropsType = {
    name: string
    placement: string
    buttonLabel: string
}

const DownloadOrderConfirmationButton = (
    props: DownloadOrderConfirmationButtonPropsType,
) => {
    const { name, placement, buttonLabel } = props

    const client = useApolloClient()
    const [loading, setLoading] = useState<boolean>(false)

    const onClickDownload = (evt: Event) => {
        evt.preventDefault()

        downloadInvoiceUri({
            client,
            setLoading,
            variables: { name },
        })
    }

    const isOrderOffPlatform = name.includes('-')

    if (isOrderOffPlatform) {
        return null
    }

    return (
        <Button
            data-test-target="download-invoice"
            disabled={loading}
            name="download-invoice"
            onClick={onClickDownload}
            placement={placement}
            style={BUTTON_MARGIN}
            type={buttonLabel === ORDER_CONFIRMATION ? 'primary' : 'default'}
        >
            {loading ? <LoadingOutlined /> : <DownloadOutlined />}
            {buttonLabel}
        </Button>
    )
}

export default DownloadOrderConfirmationButton
